<template>
  <div class="list row">
    <div class="col-md-12">
      <h4><font-awesome-icon icon="tree" /> Account Data</h4>
    </div>
    <div class="col-md-12 hgap"></div>
    
    <div class="col-md-6">
      <h4><font-awesome-icon icon="table" /> PPV and NDC Stats</h4>
      <table class="table table-striped table-bordered table-sm">
        <tr>
            <th>Personal Product Value (PPV):</th><th>Group Product Value (GPV):</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" @click="toggleClass(this,'selected')">
            <td>{{ totalPpv }}</td><td>{{ totalNdc }}</td>
        </tr>
      </table>

    </div> 

    <div class="col-md-6">
      <h4><font-awesome-icon icon="table" /> Accumulated Bonus</h4>
      <table class="table table-striped table-bordered table-sm">
        <tr>
            <th>Total Acc. Bonus</th><th>Total Paid. Bonus</th><th>Total UnPaid. Bonus</th><th>Lost Bonus</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" @click="toggleClass(this,'selected')">
            <td>{{ totalAccBonus }}</td><td>{{ totalPaidBonus }}</td><td>{{ totalUnPaidBonus }}</td><td>{{ totalNdc }}</td>
        </tr>
      </table>

      <span>
        <!-- <a class="badge badge-primary alignright" :href="'/bonuslist/' + currentMemberId"><font-awesome-icon icon="arrow-alt-circle-left" /> Bonus List</a>-->
        <router-link :to="{ path: '/bonuslist/' + currentMemberId }" class="badge badge-primary alignright"><font-awesome-icon icon="arrow-alt-circle-left" /> Bonus List </router-link>
      </span>

    </div> 

    <div class="col-md-12 hgap"></div>
    
    <div class="col-md-6">
      <h4><font-awesome-icon icon="table" /> Monthly Activation List</h4>
      <table class="table table-striped table-bordered table-sm">
        <tr>
            <th>Network ID</th><th>PV Paid</th><th>Bonus Earned (&#8358;)</th><th>Date</th><th>Status</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" v-for="(monthlyActivationPv, index) in monthlyActivationPvs" :key="monthlyActivationPv.id" @click="toggleClass(this,'selected')">
            <td>{{ monthlyActivationPv.mactivation_pv_member_id }}</td><td>{{ monthlyActivationPv.ma_pv }}</td><td>{{ monthlyActivationPv.bonus }}</td><td>{{ monthlyActivationPv.ma_date }}</td>
            <td>Paid</td>
        </tr>
      </table>

      <p><b>Total Pv Due:</b><span> {{ totalMaPv }}</span> <b>Total Pv Paid:</b><span> {{ totPaidActivation }}</span></p>
     
    </div> 

    <div class="col-md-6">
      <h4><font-awesome-icon icon="table" /> Award List</h4>
      <table class="table table-striped table-bordered table-sm">
        <tr>
            <th>Network ID</th><th>Award Date</th><th>Award</th><th>Payment Status</th><th>Payment Date</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" v-for="(memberAward, index) in memberAwards" :key="memberAward.id" @click="toggleClass(this,'selected')">
            <td>{{ memberAward.member_award_member_id }}</td><td>{{ memberAward.award_date }}</td><td>{{ memberAward.name }}</td><td v-if="memberAward.paid"> Paid </td>
            <td v-else> Not paid </td><td>{{ memberAward.payment_date }}</td>
        </tr>
      </table>
    </div>

    <div class="col-md-12 hgap"></div>

    <div class="col-md-6">
      <h4><font-awesome-icon icon="table" /> Payouts</h4>
      <table class="table table-striped table-bordered table-sm">
        <tr>
            <th>Network ID</th><th>Bonus Paid (&#8358;)</th><th>Date</th><th>Status</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" v-for="(memberPayout, index) in memberPayouts" :key="memberPayout.id" @click="toggleClass(this,'selected')">
            <td>{{ memberPayout.member_bonus_member_id }}</td><td>{{ memberPayout.bonusAmount }}</td><td>{{ memberPayout.payment_date }}</td>
            <td>Paid</td>
        </tr>
      </table>
     
    </div>

    <div class="col-md-6">
      <h4><font-awesome-icon icon="table" /> Products List</h4>
      <table class="table table-striped table-bordered table-sm">
        <tr>
            <th>Network ID</th><th>Product</th><th>Price</th><th>PV</th><th>Quantity</th><th>Date Purchased</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" v-for="(sale, index) in sales" :key="sale.id" @click="toggleClass(this,'selected')">
            <td>{{ sale.sale_member_id }}</td><td>{{ sale.name }}</td><td>{{ sale.unit_price }}</td><td>{{ sale.pv }}</td>
            <td>{{ sale.quantity }}</td><td>{{ sale.sold_date | moment("dddd, MMMM Do YYYY") }}</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import SaleService from "../services/sale.service";
//import MemberService from "../services/member.service";
import MemberBonusService from "../services/member-bonus.service";
import MonthlyActivationPvService from "../services/monthly-activation-pv.service";
import MemberAwardService from "../services/member-award.service";

export default {
  name: "acc-data",
  data() {
    return {
      currentMemberId: 0,
      totalPpv: 0,
      totalNdc: 0,
      totalAccBonus: 0,
      totalPaidBonus: 0,
      totalUnPaidBonus: 0,
      monthlyActivationPvs: [],
      totPaidActivation: 0,
      totalMaPv: 0,
      memberAwards: [],
      memberPayouts: [],
      sales: [],
      currentIndex: 0,

    };
  },
  methods: {
    getTotalPpv(memberId) {
      this.totalPpv = 0;
      SaleService.getTotalPpv(memberId)
        .then(response => {
          this.totalPpv = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    /*getTotalNdc(memberId) {
      //this.totalNdc = 0;
      MemberService.getDescendantsForNdcBySponsor(memberId)
        .then(response => {
          this.descendants = response.data;
          for(let descendant of this.descendants) {
            SaleService.getTotalPpv(descendant.id)
              .then(response => {
                this.totalNdc = this.totalNdc + response.data;
              })
              .catch(e => {
                console.log(e);
              });
          }
        })
        .catch(e => {
          console.log(e);
        });      
    },*/

    getTotalNdc(memberId) {
      //this.totalNdc = 0;
      SaleService.getTotalNdc(memberId)
        .then(response => {
          this.totalNdc = response.data;
        })
        .catch(e => {
          console.log(e);
        });      
    },

    getTotalAccBonus(memberId) {
      MemberBonusService.getTotalBonus(memberId)
        .then(response => {
          this.totalAccBonus = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getTotalPaidBonus(memberId) {
      MemberBonusService.getTotalPaidBonus(memberId)
        .then(response => {
          this.totalPaidBonus = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getTotalUnPaidBonus(memberId) {
      MemberBonusService.getTotalUnPaidBonus(memberId)
        .then(response => {
          this.totalUnPaidBonus = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getMonthlyActivationPvs(memberId) {
      MonthlyActivationPvService.getMonthlyActivationPvs(memberId)
        .then(response => {
          this.monthlyActivationPvs = response.data;
          for(let monthlyActivationPv of this.monthlyActivationPvs) {
            this.totPaidActivation = this.totPaidActivation + monthlyActivationPv.ma_pv
          }  
        })
        .catch(e => {
          console.log(e);
        });
    },

    getTotalMaPv(memberId) {
      MonthlyActivationPvService.getTotalMaPv(memberId)
        .then(response => {
          this.totalMaPv = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getMemberAwardsByMemberId(memberId) {
      MemberAwardService.getMemberAwardsByMemberId(memberId)
        .then(response => {
          this.memberAwards = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getPayoutsByMember(memberId) {
      MemberBonusService.getPayoutsByMember(memberId)
        .then(response => {
          this.memberPayouts = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getSalesAndProductsByMember(memberId) {
      SaleService.getSalesAndProductsByMember(memberId)
        .then(response => {
          this.sales = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    toggleClass(el, className) {
      if (el.className.indexOf(className) >= 0) {
         el.className = el.className.replace(className,"");
      }
      else {
        el.className  += className;
      }
    },

    membersList() {
      this.$router.push('/members');
    }

  },
  mounted() {
    this.currentMemberId = this.$route.params.id;
    this.getTotalPpv(this.$route.params.id);
    this.getTotalNdc(this.$route.params.id);
    this.getTotalAccBonus(this.$route.params.id);
    this.getTotalPaidBonus(this.$route.params.id);
    this.getTotalUnPaidBonus(this.$route.params.id);
    this.getMonthlyActivationPvs(this.$route.params.id);
    this.getTotalMaPv(this.$route.params.id);
    this.getMemberAwardsByMemberId(this.$route.params.id);
    this.getPayoutsByMember(this.$route.params.id);
    this.getSalesAndProductsByMember(this.$route.params.id);
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}
.alignright{
  float: right;
}
</style>